export const shortenAddress = ({
  address,
  leadingChars = 4,
  tailingChars = 4,
}: {
  address: string;
  leadingChars?: number;
  tailingChars?: number;
}): string => {
  return `${address.slice(0, leadingChars)}...${address.slice(-tailingChars)}`;
};
